import { useLocation, useNavigate, useParams } from "react-router-dom";
import Usuarios from "../../page/usuarios/Usuarios";
import { authContext } from "../../../../context/auth/AuthContext";
import { useContext, useEffect, useState } from "react";
import apiPrivateAntesala from "../../../config/ConfigPrivate";
import RestPrivateAntesala from "../../../helpers/RestPrivateApi";
import Alerts from "../../components/Alerts/Alerts";
import * as XLSX from 'xlsx';
import { format } from "date-fns";
import { Rol } from "../../../utils/Rol";

const UsuariosController = () => {
  const location = useLocation();
  const getParams = new URLSearchParams(location.search);
  const navigate = useNavigate();
  const { user } = useContext(authContext);
  const { data } = user;
  const [filter, setFilter] = useState({
    //["filter[provincia]"]: "Córdoba",
    //["filter[fecha]"]: format(new Date(), "yyyy-M-dd").toString(), //FullMonth(new Date()),
    sort: "-id",
    per_page: 50,
  });
  const [provincias, setProvincias] = useState(null);
  const [usuarios, setUsuarios] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showExportModal, setShowExportModal] = useState(false);
  let controller;

  const onClick = async (e, value) => {
    switch (e.target.name) {
      case "status": {

        let formData = new FormData();
        formData.append("_method", "PUT");
        formData.append("id", value.usuario.id);

        /*Evento*/
        formData.append("status_id", value.status);

        const response = await RestPrivateAntesala({
          url: `/usuarios/${value.usuario.id}`,
          formData: formData,
          method: "post",
          setLoading: setLoading,
        });

        //Error
        if (response.status == 201 || response.status == 200) {
          controller = new AbortController();
          const signal = AbortController.signal;
          fetch(setUsuarios, filter, "/usuarios", signal);
          return Alerts({
            msg: "Alert",
            title: response.data.msg,
            code: "401",
            type: "success",
          });
        } else {
          if (typeof response.data.msg === "string") {
            return Alerts({
              msg: "Alert",
              title: response.data.msg,
              code: "200",
              type: "success",
            });
          }

          Object.keys(response.data.msg).map((key) => {
            return Alerts({
              msg: "Alert",
              title: response.data.msg[key][0],
              code: "401",
              type: "error",
            });
          });
        }
      } break;
      case "añadir-usuario":
        {
          return navigate("/dashboard/usuarios/nuevo");
        }
        break;
      case "editar-usuario":
        {
          return navigate("/dashboard/usuarios/" + value);
        }
        break;
      case "exportar-excel":
        {
          setShowExportModal(true);
        }
        break;
    }
  };

  const handleExportarExcel = async (columnasSeleccionadas) => {
    try {
      setLoading(true);

      // Obtener todos los usuarios sin paginación
      const params = {
        ...filter,
        per_page: usuarios?.total || 1000, // Usar el total de usuarios
      };

      const response = await apiPrivateAntesala.get("/usuarios", { params });

      if (response.status === 200 || response.status === 201) {
        const todosLosUsuarios = response.data.data;

        // Preparar datos según columnas seleccionadas
        const datosExcel = todosLosUsuarios.map((usuario) => {
          const fila = {};

          if (columnasSeleccionadas.id) fila["ID"] = usuario.id;
          if (columnasSeleccionadas.nombre) fila["Nombre"] = usuario.nombre;
          if (columnasSeleccionadas.email) fila["Email"] = usuario.email;
          if (columnasSeleccionadas.rol) fila["Rol"] = Rol(usuario.rol[0].nombre);
          if (columnasSeleccionadas.estado) fila["Estado"] = usuario.status.nombre;
          if (columnasSeleccionadas.creado) {
            fila["Fecha de Creación"] = format(
              new Date(usuario.created_at),
              "dd/MM/yyyy"
            );
          }

          return fila;
        });

        // Crear hoja de trabajo
        const worksheet = XLSX.utils.json_to_sheet(datosExcel);

        // Crear libro de trabajo
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Usuarios");

        // Generar archivo Excel
        const fechaActual = format(new Date(), "yyyy-MM-dd_HHmmss");
        XLSX.writeFile(workbook, `Usuarios_${fechaActual}.xlsx`);

        Alerts({
          msg: "Éxito",
          title: "Excel exportado correctamente",
          code: "200",
          type: "success",
        });
      }
    } catch (error) {
      Alerts({
        msg: "Error",
        title: "Error al exportar Excel",
        code: "500",
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const onChange = async (e, value) => {
    switch (e.target.name) {
      case "search":
        {
          if (controller) controller.abort();

          controller = new AbortController();
          const signal = AbortController.signal;

          let params = {
            ...filter,
            ["filter[search]"]: e.target.value,
          };

          setFilter({ ...params });

          return fetch(setUsuarios, params, "/usuarios", signal);
        }
        break;
      case "":
        {
        }
        break;
    }
  };

  const fetch = async (setData, params, url, signal) => {
    const response = await apiPrivateAntesala.get(url, { params, signal });
    if (response.status == 201 || response.status == 200) {
      setData(response.data);
    }
  };

  useEffect(() => {
    let params = {
      ...filter,
    };

    if (getParams.get("tipo")) {
      params = {
        ...params,
        ["filter[tipos.id]"]: getParams.get("tipo"),
      };

      setFilter({ ...params })
    }

    fetch(setUsuarios, params, "/usuarios");
  }, [location]);

  useEffect(() => {
    if (!provincias) {
      fetch(setProvincias, {}, "/provincias");
    }
  }, []);

  return (
    <Usuarios
      filter={filter}
      setFilter={setFilter}
      fetch={fetch}
      data={usuarios ?? { data: [], links: [] }}
      setData={setUsuarios}
      onClick={onClick}
      onChange={onChange}
      provincias={provincias ?? []}
      navigate={navigate}
      user={data}
      setLoading={setLoading}
      showExportModal={showExportModal}
      setShowExportModal={setShowExportModal}
      onExportarExcel={handleExportarExcel}
    />
  );
};

export default UsuariosController;
